import React from 'react';
import { Col, Form, FormGroup, FormText, Label, Input, ModalBody, Row, FormFeedback, ModalFooter, Button } from 'reactstrap';
import { SearchAsync } from '../../components/elements/SearchAsync';
import Datetime from 'react-datetime';
import 'moment/locale/es';
import "react-datetime/css/react-datetime.css";
import { ModalButtonCancel } from '../../constant';

export const FormPrices = (props) => {

    const {
        toggle, loading, handleInputChange, price, from, to,
        validacionesPrice, methodAction, id_examProfile,
        examProfileState, handlePickerValues, validInputDate, validToInputDate, button,
        isCurve, curves, addCurve, editCurve
    } = props;

    const {
        id_examProfile_valid,
        price_valid,
        from_valid
    } = validacionesPrice;

    // ////console.log(curves);

    return (
          <Form className="formPricesModern" role="form" onSubmit={methodAction}>

            <div className="sectionFormPrices">

                <div className="titleSectionForm">
                    Información general
                </div>

                <Row>
                    <Col md="12">
                        <FormGroup>

                            <Label className="labelModern">
                                Nombre de la prueba
                                <span className="required-price">*</span>
                            </Label>

                            <SearchAsync
                                value={id_examProfile}
                                name="id_examProfile"
                                method={handleInputChange}
                                loincState={examProfileState}
                                url={`Profiles/SearchProfileExam?just_exams=true`}
                                maxLenght={3}
                            />

                            <FormText
                                color="danger"
                                hidden={!id_examProfile_valid}
                            >
                                Debes seleccionar una opción
                            </FormText>

                        </FormGroup>
                    </Col>
                </Row>

                {
                    !isCurve &&
                    <Row>
                        <Col md="12">

                            <FormGroup>

                                <Label className="labelModern">
                                    Precio
                                    <span className="required-price">*</span>
                                </Label>

                                <div className="inputMoneyWrapper">

                                    <span className="moneyIcon">
                                        $
                                    </span>

                                    <Input
                                        className="inputModern"
                                        type="number"
                                        step="any"
                                        min="0"
                                        name="price"
                                        value={price}
                                        invalid={price_valid}
                                        onKeyDown={(e) => {
                                            if (
                                                e.key === '-' ||
                                                e.key === '+' ||
                                                e.key === 'e'
                                            ) {
                                                e.preventDefault();
                                            }
                                        }}
                                        onChange={handleInputChange}
                                    />

                                </div>

                                <FormFeedback>
                                    Debes llenar este campo
                                </FormFeedback>

                            </FormGroup>

                        </Col>
                    </Row>
                }

            </div>

            <div className="sectionFormPrices mt-3">

                <div className="titleSectionForm">
                    Vigencia del precio
                </div>

                <Row>

                    <Col md="6">

                        <Label className="labelModern">
                            Válido desde
                            <span className="required-price">*</span>
                        </Label>

                      <Datetime
                            inputProps={{
                                placeholder: 'dd-mm-aaaa hh:mm:ss',
                                name: 'from',
                                autoComplete: "off",
                                className: "form-control digits form-control-sm inputModern"
                            }}
                            timeFormat="HH:mm:ss"
                            timeConstraints={{
                                hours: { min: 0, max: 23 },
                                minutes: { min: 0, max: 59 },
                                seconds: { min: 0, max: 59 }
                            }}
                            value={from}
                            dateFormat={true}
                            locale="es"
                            onChange={(e) => handlePickerValues(e, "from")}
                            isValidDate={validInputDate}
                        />

                    </Col>

                    <Col md="6">

                        <Label className="labelModern">
                            Válido hasta
                        </Label>

                        <Datetime
                            inputProps={{
                                placeholder: 'dd-mm-aaaa hh:mm:ss',
                                name: 'to',
                                autoComplete: "off",
                                className: "form-control inputModern"
                            }}
                            timeFormat="HH:mm:ss"
                            value={to}
                            dateFormat={true}
                            locale="es"
                            onChange={(e) => handlePickerValues(e, "to")}
                            isValidDate={validToInputDate}
                        />

                    </Col>

                    

                </Row>
 {/* <ModalFooter>
                <Button
                    size="sm"
                    outline
                    color="primary"
                    type="submit"
                    className={loading ? "disabled progress-bar-animated progress-bar-striped" : ""}
                >
                    {button}
                </Button>
                <Button size="sm" outline color='danger' type="button" onClick={toggle}>{ModalButtonCancel}</Button>
            </ModalFooter> */}
            </div>

        </Form>
        
    )


}
